// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__rOAJ9","colMaxWidth":"Table_colMaxWidth__GBmf5"};